import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";
import Button from "../../../components/ui/Button";
import styles from "./TextTab.module.css";

interface TextTabProps {
    name: string;
    onAddText: (payload: { name: string; text: string }) => void;
    textItemsCount?: number;
}

const TextTab: React.FC<TextTabProps> = ({ name, onAddText, textItemsCount = 0 }) => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;
    const [textSample, setTextSample] = useState("");

    const handleSubmit = () => {
        const payload = { name: name.trim(), text: textSample.trim() };
        onAddText(payload);
        setTextSample("");
    };

    const isMaxReached = textItemsCount >= 3;
    const isDisabled = !textSample.trim() || !name.trim() || isMaxReached;
    const getTooltipMessage = () => {
        if (isMaxReached) {
            return t("brandVoices.maxTextExtractsReached") || "Maximum of 3 text extracts reached";
        }
        if (!name.trim() && !textSample.trim()) {
            return t("brandVoices.missingNameAndText");
        }
        if (!name.trim()) {
            return t("brandVoices.missingName");
        }
        if (!textSample.trim()) {
            return t("brandVoices.missingText");
        }
        return "";
    };

    return (
        <div className={styles.container}>
            <textarea
                value={textSample}
                onChange={(e) => setTextSample(e.target.value)}
                placeholder={t("brandVoices.copyPlaceholder")}
                className={styles.textarea}
            />
            <div className={styles.actions}>
                <Tooltip title={isDisabled ? getTooltipMessage() : ""} arrow>
                    <span>
                        <Button
                            variant="primary"
                            label={t("brandVoices.addTextButton")}
                            onClick={handleSubmit}
                            disabled={isDisabled}
                        />
                    </span>
                </Tooltip>
            </div>
        </div>
    );
};

export default TextTab;
